import { render, staticRenderFns } from "./Rejectionemail.vue?vue&type=template&id=0d2ceb01&scoped=true&"
import script from "./Rejectionemail.vue?vue&type=script&lang=js&"
export * from "./Rejectionemail.vue?vue&type=script&lang=js&"
import style0 from "./Rejectionemail.vue?vue&type=style&index=0&id=0d2ceb01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2ceb01",
  null
  
)

export default component.exports